'use strict';
class QuickSearch {
    constructor() {
        this.mobileSearchEl = document.querySelector('.search--moby');
        const searchButton = document.querySelector('.search__button--moby');
        this.toggleSearch = this.toggleSearch.bind(this);
        if (searchButton) {
            searchButton.addEventListener('click', this.toggleSearch);
        }
    }
    toggleSearch() {
        if (this.mobileSearchEl) {
            this.mobileSearchEl.classList.toggle('hidden');
            if (this.mobileSearchEl.offsetParent) {
                this.mobileSearchEl.querySelector('input').focus();
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new QuickSearch();
});


// WEBPACK FOOTER //
// ./Components/search/quick-search.js